export default __webpack_public_path__ + "static/Pavel Sviridov-f0e64334e427b6de6447b1826acf3f19.png";